module.exports = __webpack_public_path__ + "assets/filters_new_large-98eda0.svg";